<soho-header #SohoHeader [hasToolbar]="hasToolbar" [class.has-breadcrumb]="hasBreadcrumbs">

  <!--
  UPLIFT WORK - removing app title 
  [pageTitle]="webAppTitle"
    [attr.id]="toolbarId"
  -->
  <lm-toolbar
      [inHeader]="true"
      [automationId]="screenAutomationId"
      [showGoBack]="showGoBack"
      [sectionTitle]="toolbarSectionTitle"
      [toolbarIdPrefix]="screenId"
      [asOfDate]="asOfDate"
      [showArchive]="showArchive"
      [buttons]="toolbarButtons | async"
      [disabled]="disabled"
      [searchField]="toolbarSearchField"
      [mustacheText]="mustacheText"
      [moreMenuSettings]="toolbarMoreSettings"
      [isCreateReportMode]="isCreateReportMode$ | async"
      (toolbarBackButtonEvent)="onToolbarBackButtonEvent()"
      (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      (toolbarSearchEvent)="onToolbarSearchEvent($event)"
      (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent($event)"
      (asOfDateChangedEvent)="onAsOfDateChangedEvent($event)"
      (asOfDateClearedEvent)="onAsOfDateCleared()"
      (quitArchiveViewEvent)="onQuitArchiveView()"
  ></lm-toolbar>

  <ng-container *ngIf="hasBreadcrumbs">
    <ng-container *ngIf="useWC; else SohoComp">
      <div class="lm-banner-breadcrumbs-container">
        <ids-breadcrumb #breadcrumb color-variant="breadcrumb" truncate="true">
          <ng-container *ngFor="let breadCrumbItem of breadcrumbs">
            <ids-hyperlink
                font-size="14"
                font-weight="breadCrumbItem.current === true ? 'semibold':null"
                color-variant="breadcrumb"
                [attr.target-id]="breadCrumbItem.id"
                text-decoration="hover"
            >{{breadCrumbItem.content}}</ids-hyperlink>
          </ng-container>
        </ids-breadcrumb>
      </div>
    </ng-container>
    <ng-template #SohoComp>
      <section class="scrollable-flex-header has-breadcrumb">
        <nav #SohoBreadcrumb soho-breadcrumb class="breadcrumb" [breadcrumbs]="breadcrumbs" style="position: fixed;"></nav>
      </section>
    </ng-template>
  </ng-container>
</soho-header>
